var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hero-banner"},[_c('div',{staticClass:"hero-banner__inner"},[_c('div',{staticClass:"hero-banner__content"},[_c('span',{staticClass:"hero-banner__tag"},[_vm._v("FAQ")]),_vm._v(" "),_c('h1',[_vm._v("PinMe 餐飲POS系統｜"),_c('br'),_vm._v("香港餐廳老闆常見問題解答")])])])])
}]

export { render, staticRenderFns }